import {
  faBars,
  faInfo,
  faStar,
  faWifi,
  faXmark,
  faTrash,
  faCheck,
  faCircle,
  faFilter,
  faBookOpen,
  faArrowUpAZ,
  faCircleInfo,
  faChevronLeft,
  faRotateRight,
  faChevronRight,
  faSortAlphaAsc,
  faSortAlphaDown,
  faCloudArrowDown,
  faMagnifyingGlass,
  faArrowUpShortWide,
  faArrowDownShortWide,
  faEnvelopeCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

import { faStar as faStarAlternative } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(
  faBars,
  faWifi,
  faXmark,  
  faCircle,
  faChevronLeft,
  faChevronRight,
  faSortAlphaAsc,
  faSortAlphaDown,
  faMagnifyingGlass,
  faArrowUpShortWide,
  faArrowDownShortWide,
);

const svgFonts = {
  faBars,
  faInfo,
  faStar,
  faWifi,
  faXmark,
  faTrash,
  faCheck,
  faCircle,
  faFilter,
  faBookOpen,
  faArrowUpAZ,
  faCircleInfo,
  faChevronLeft,
  faRotateRight,
  faChevronRight,
  faSortAlphaAsc,
  faSortAlphaDown,
  faCloudArrowDown,
  faMagnifyingGlass,
  faStarAlternative,
  faArrowUpShortWide,
  faArrowDownShortWide,
  faEnvelopeCircleCheck,
};

export default svgFonts;
